import { createContext, useContext } from 'react';

export const MobileAlertContext = createContext(null);

export const useMobileAlert = () => {
  const context = useContext(MobileAlertContext);

  if (!context) {
    throw new Error('useMobileAlert must be used within a MobileAlertProvider');
  }

  return context;
};
